// src/components/StreetRangesTable.js (Versión Completa y Funcional con DELETE)
import React from 'react';
import { Paper, Typography, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const StreetRangesTable = ({ ranges, loading, error, onEditClick, onDeleteClick }) => {
  const columns = [
    { field: 'route', headerName: 'Route', width: 90 },
    { field: 'street_name', headerName: 'Street Name', flex: 1, minWidth: 200 },
    { field: 'start_number', headerName: 'Start #', width: 110 },
    { field: 'end_number', headerName: 'End #', width: 110 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => onEditClick(params.row)} aria-label="edit">
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => onDeleteClick(params.row)} aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  if (loading) return <Typography>Loading data...</Typography>;
  if (error) return <Typography color="error">Error fetching data: {error}</Typography>;

  return (
    <Paper sx={{ height: 650, width: '100%' }}>
      <DataGrid
        rows={ranges}
        columns={columns}
        getRowId={(row) => row.range_id}
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
        }}
        checkboxSelection
        disableRowSelectionOnClick
      />
    </Paper>
  );
};

export default StreetRangesTable;
